// extracted by mini-css-extract-plugin
module.exports = {"freeFrom":"FreeFrom_freeFrom__n8IEN","title":"FreeFrom_title__PwHeT","list":"FreeFrom_list__eRsjF","listItem":"FreeFrom_listItem__L8ADq"};